/*
 * @Descripttion:
 * @version:
 * @Author:
 * @Date: 2020-03-30 15:59:46
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-09-22 14:40:33
 */
import axios from "axios";

axios.defaults.headers.common["X-Authorization-Token"] = "Bearer-nil";
axios.defaults.headers.common["protocol"] =
  "14421feb1c9ea719b94bb651bd2667affenzhidao";
// axios.defaults.headers.common['timestamp'] = Date.parse(new Date()).toString().substr(0, 10);
axios.defaults.headers.common["timestamp"] = "1568690455";

const service = axios.create({
  timeout: 10000,
  baseURL: process.env.VUE_APP_BASE_URL,
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    service
      .get(url, {
        params: params,
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    service
      .post(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
